import React from "react";
import GameModuleFrame from "../../game-platform/GameModuleFrame";

export const escapeBoxCapabilities = Object.freeze({
  map: false,
  location: false,
  timedQuestions: false,
  physicalItems: true,
});

const escapeBoxDefaults = Object.freeze({
  backgroundColor: "#15110C",
  surfaceColor: "#211A12",
  textColor: "#F3E8D1",
  accentColor: "#C29A5B",
  textureOpacity: 0.25,
});

export default function EscapeBoxGameApp(props) {
  return (
    <GameModuleFrame
      {...props}
      moduleId="escape_box"
      defaults={escapeBoxDefaults}
      capabilities={escapeBoxCapabilities}
    />
  );
}
